export const GoParametersTextConstants = {
    erpTooltip:
        'Examples are provided. Use different data if relevant for your needs.',
} as const;
